import React, { useRef } from "react";
import { TextField, Button, Box, Typography, Paper, Divider } from "@mui/material";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";
import SocialMedia from "../SocialMedia/SocialMedia";

const EnquiryForm = () => {
    const form = useRef();
    const navigate = useNavigate();

    const sendEmail = (e) => {
        e.preventDefault();

        emailjs
            .sendForm(
                "service_eqf9qid",
                "template_41d3duo",
                form.current,
                { publicKey: "e70SHpBXhK2elvQum" }
            )
            .then(
                () => {
                    form.current.reset();
                    alert("Your data submitted successfully!");
                    navigate("/");
                },
                (error) => {
                    alert("Please fill mandatory fields properly!", error.text);
                }
            );
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                p: 2,
                mt: 10,
                animation: "fadeIn 1s ease-in-out",
                "@keyframes fadeIn": {
                    from: { opacity: 0 },
                    to: { opacity: 1 },
                },
            }}
        >
            <Paper
                elevation={8}
                sx={{
                    p: { xs: 3, md: 4 },
                    width: { xs: "100%", sm: "85%", md: "450px" },
                    borderRadius: "16px",
                    backdropFilter: "blur(10px)",
                    background: "rgba(255, 255, 255, 0.85)",
                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
                    animation: "slideUp 0.8s ease-out",
                    "@keyframes slideUp": {
                        from: { transform: "translateY(50px)", opacity: 0 },
                        to: { transform: "translateY(0)", opacity: 1 },
                    },
                }}
            >
                <Typography
                    variant="h5"
                    textAlign="center"
                    sx={{
                        mb: 3,
                        fontWeight: "bold",
                        color: "#030366",
                    }}
                >
                    Enquiry Form
                </Typography>

                <form ref={form} onSubmit={sendEmail}>
                    <TextField
                        label="Full Name"
                        name="from_name"
                        fullWidth
                        required
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Email"
                        name="from_email"
                        type="email"
                        fullWidth
                        required
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Mobile Number"
                        name="from_mobile"
                        type="number"
                        fullWidth
                        required
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Message"
                        name="message"
                        multiline
                        rows={4}
                        fullWidth
                        required
                        sx={{ mb: 2 }}
                    />

                    <Button
                        type="submit"
                        variant="contained"
                        fullWidth
                        sx={{
                            py: 1.3,
                            fontSize: "1rem",
                            fontWeight: "bold",
                            textTransform: "none",
                            borderRadius: "10px",
                            backgroundColor: "#030366",
                            transition: "0.3s",
                            "&:hover": {
                                backgroundColor: "#1a1a80",
                                transform: "scale(1.03)",
                            },
                        }}
                    >
                        Submit
                    </Button>
                </form>

                <Divider sx={{ bgcolor: "rgba(255,255,255,0.3)", width: "75%", margin: "20px auto" }} />

                <SocialMedia />
            </Paper>
        </Box>
    );
};

export default EnquiryForm;
